<template>
  <span :class="style.heading">Google таблицы</span>
  <div :class="style.inputs" v-if="edit">
    <InputStyle
      description="URL"
      size="M"
      readOnly
      v-model="localIntegration"
    />
  </div>
  <div :class="style.buttons" :style="{marginTop: !edit ? '16px' : ''}">
    <PrimaryButton text="Авторизоваться" v-if="!edit" @click="authGoogle" />
    <PrimaryButton text="Обновить" v-if="edit" @click="postGoogle" />
    <SecondaryButton
      text="Удалить"
      v-if="edit"
      :icon="trashIcon"
      @click="$emit('delete')"
    />
  </div>
</template>

<script lang="ts">
import style from "./settingIntegrations.module.scss";
import {defineComponent} from "vue";
import SecondaryButton from "@/elements/UI/button/ButtonStyle/Default/secondary/SecondaryButton.vue";
import trashIcon from "$images/icons/button/Name=Trash, Size=16, Tone=Default.svg";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";
import type {googleIntegration} from "@/page/setting/integration/IntegrationTypes";
import {API} from "@/api/generated";

function isGoogleIntegration(
  integration: unknown
): integration is googleIntegration {
  return (
    typeof integration == "object" &&
    integration != null &&
    "spreadsheetId" in integration
  );
}

export default defineComponent({
  name: "SettingIntegrationGoogle",

  components: {InputStyle, PrimaryButton, SecondaryButton},
  emits: ["delete", "closeModal"],
  props: {
    edit: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      style,
      trashIcon,
      localIntegration: ""
    };
  },
  mounted() {
    this.localIntegration = this.googleUrl;
  },

  methods: {
    async authGoogle() {
      try {
        localStorage.setItem("integration", "google");

        const authUrl = await API.getAuthorizationUrl();

        window.location.href = authUrl;
      } catch (e) {
        console.error("Google auth start error", e);
      }
    },
    async postGoogle() {
      try {
        await API.setTable();
      } catch (error) {
        console.error("Ошибка при обновлении Google-интеграции:", error);
      }

      this.$emit("closeModal");
    }
  },
  computed: {
    googleUrl(): string {
      const integration = this.getIntegration.google.integration[0];
      if (!isGoogleIntegration(integration) || !integration.spreadsheetId) {
        return "";
      }
      return `https://docs.google.com/spreadsheets/d/${integration.spreadsheetId}`;
    },
    getIntegration() {
      return this.$integrationStore.getIntegration;
    }
  }
});
</script>
